export function formatValor(valor, language, mostraPercentual = false) {
    // converte para número
    const num = Number(valor);

    // trata casos não-numéricos
    if (!Number.isFinite(num)) return "-";

    // escolhe quantidade de casas decimais
    const options = {
        minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
        maximumFractionDigits: 2,
    };

    // aplica pontuação pt-BR
    const numeroFormatado = language == "pt" ? num.toLocaleString("pt-BR", options) : num.toLocaleString("en-US", options);

    //const numeroFormatado = num.toLocaleString("en-US", options);


    // acrescenta símbolo de % se solicitado
    return numeroFormatado + (mostraPercentual ? "%" : "");
}

export function getSemanaDoAno(dateStr){
    const date = new Date(dateStr);
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNum = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    const weekStr = String(weekNum).padStart(2, '0');
    return `${weekStr}-${d.getUTCFullYear()}`;
};